import type { CSSProperties, FC, ReactNode } from 'react';
import { useDrag } from 'react-dnd';
import { ItemTypes } from './ItemTypes';


const style: CSSProperties = {
    position: 'absolute',
    cursor: 'move',
};

export interface BoxProps {
    id: any;
    left: number;
    top: number;
    hideSourceOnDrag?: boolean;
    children?: ReactNode;
}

export const Box: FC<BoxProps> = ({
    id,
    left,
    top,
    hideSourceOnDrag,
    children,
}) => {
    const [{ isDragging }, drag] = useDrag(
        () => ({
            type: ItemTypes.BOX,
            item: { id, left, top },
            collect: (monitor) => ({
                isDragging: monitor.isDragging(),

            }),
        }),
        [id, left, top],
    );

    if (isDragging && hideSourceOnDrag) {
        return drag(<div></div>);
    }
    return drag(
        <div
            className={ItemTypes.BOX}
            style={{ ...style, left, top }}
            data-testid="box"
        >
            {children}
        </div>
    );
};
